/* unplugin-vue-components disabled */import script from "./VuecmfEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./VuecmfEditor.vue?vue&type=script&lang=ts&setup=true"

import "./VuecmfEditor.vue?vue&type=style&index=0&id=496241ea&lang=scss&scoped=true"
import "./VuecmfEditor.vue?vue&type=style&index=1&id=496241ea&lang=scss"

import exportComponent from "D:\\git\\vue-vuecmf-editor\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-496241ea"]])

export default __exports__